<template>
  <div class="auth-manage-bg">
    <div class="auth-header">
      <div class="auth-header-back" @click="$router.back()">
        <svg width="24" height="24" viewBox="0 0 24 24"><path d="M15.5 19l-7-7 7-7" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>
      </div>
      <div class="auth-header-title">实名认证</div>
    </div>
    <div class="auth-card">
      <div class="auth-item">
        <div class="auth-item-label">姓名</div>
        <input class="auth-item-input" v-model="form.name" placeholder="请输入姓名" />
      </div>
      <div class="auth-item auth-select-wrap">
        <div class="auth-item-label">证件类型</div>
        <div class="auth-item-select" @click="toggleIdTypeOptions">
          <span :class="{'placeholder': !form.idType}">{{ form.idType || '请选择证件类型' }}</span>
          <svg class="select-arrow" width="16" height="16" viewBox="0 0 16 16">
            <path d="M4.5 6l3.5 3.5L11.5 6" stroke="currentColor" stroke-width="1.5" fill="none"/>
          </svg>
        </div>
      </div>
      <!-- 选项弹出层 -->
      <div v-show="showIdTypeOptions" class="select-options-mask" @click="showIdTypeOptions = false">
        <div class="select-options" @click.stop>
          <div class="select-option" v-for="type in idTypes" :key="type.value" @click="selectIdType(type)">
            {{ type.label }}
          </div>
        </div>
      </div>
      <div class="auth-divider"></div>
      <div class="auth-item">
        <div class="auth-item-label">证件号</div>
        <input class="auth-item-input" v-model="form.idNumber" placeholder="请输入证件号" />
      </div>
      <div class="auth-divider"></div>
      <div class="auth-item">
        <div class="auth-item-label">国籍</div>
        <input class="auth-item-input" v-model="form.nationality" placeholder="请输入国籍" />
      </div>
      <div class="auth-divider"></div>
      <div class="auth-item auth-upload-label">请上传证件照片</div>
      <div class="auth-upload-row">
        <label class="auth-upload-card">
          <input class="auth-file-input" type="file" accept="image/jpeg,image/jpg,image/png,image/*" @change="onFileChange('front', $event)" />
          <img v-if="frontPreview" :src="frontPreview" class="auth-upload-img" />
          <img v-else src="../images/user/zheng.png" class="auth-upload-img" />
          <div class="auth-upload-title">证件正面</div>
          <div class="auth-upload-desc">点击上传证件人面像</div>
        </label>
        <label class="auth-upload-card">
          <input class="auth-file-input" type="file" accept="image/jpeg,image/jpg,image/png,image/*" @change="onFileChange('back', $event)" />
          <img v-if="backPreview" :src="backPreview" class="auth-upload-img" />
          <img v-else src="../images/user/fan.png" class="auth-upload-img" />
          <div class="auth-upload-title">证件反面</div>
          <div class="auth-upload-desc">点击上传证件反面</div>
        </label>
      </div>
    </div>
    <div class="auth-btn-bar">
      <button class="auth-btn" :class="{ 'auth-btn-disabled': loading }" :disabled="loading" @click="submit">提交</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Fetch from '../../utils/fetch'
import api from "../../interface/index"
export default {
  name: 'UserAuth',
  data() {
    return {
      form: {
        name: '',
        idType: '',
        idNumber: '',
        nationality: ''
      },
      idTypes: [
        { label: '身份证', value: 'idcard' },
        { label: '护照', value: 'passport' }
      ],
      showIdTypeOptions: false,
      frontFile: null,
      backFile: null,
      frontPreview: '',
      backPreview: '',
      loading: false
    };
  },
  computed: {
    hasFrontImage() {
      return !!(this.frontFile || this.frontPreview);
    },
    hasBackImage() {
      return !!(this.backFile || this.backPreview);
    },
  },
  mounted() {
    this.start();
  },
  methods: {
    toggleIdTypeOptions() {
      this.showIdTypeOptions = !this.showIdTypeOptions;
    },
    selectIdType(type) {
      this.form.idType = type.label;
      this.showIdTypeOptions = false;
    },
    onFileChange(type, e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      if (type === 'front') {
        this.frontFile = file;
      } else {
        this.backFile = file;
      }
      const reader = new FileReader();
      reader.onload = (ev) => {
        if (type === 'front') {
          this.frontPreview = ev.target.result;
        } else {
          this.backPreview = ev.target.result;
        }
      };
      reader.readAsDataURL(file);
    },
    validateForm() {
      if (!this.form.name.trim()) {
        this.$toast({ className: 'toastName', message: '请输入姓名' });
        return false;
      }
      if (!this.form.idType) {
        this.$toast({ className: 'toastName', message: '请选择证件类型' });
        return false;
      }
      if (!this.form.idNumber.trim()) {
        this.$toast({ className: 'toastName', message: '请输入证件号' });
        return false;
      }
      if (!this.form.nationality.trim()) {
        this.$toast({ className: 'toastName', message: '请输入国籍' });
        return false;
      }
      if (!this.hasFrontImage) {
        this.$toast({ className: 'toastName', message: '请上传证件正面' });
        return false;
      }
      if (!this.hasBackImage) {
        this.$toast({ className: 'toastName', message: '请上传证件反面' });
        return false;
      }
      return true;
    },
    async ensureFile(preview, file, fallbackName) {
      if (file) return file;
      if (!preview || String(preview).indexOf('data:') !== 0) return null;
      const res = await fetch(preview);
      const blob = await res.blob();
      return new File([blob], fallbackName, { type: blob.type || 'image/jpeg' });
    },
    start() {
        Fetch('/user/info').then((r) => {
            this.user = r.data;
        });
    },
    async submit() {
      if (this.loading) return;
      if (!this.validateForm()) return;
      this.loading = true;
      try {
        const front = await this.ensureFile(this.frontPreview, this.frontFile, 'front.jpg');
        const back = await this.ensureFile(this.backPreview, this.backFile, 'back.jpg');
        if (!front || !back) {
          this.$toast({ className: 'toastName', message: '请重新上传证件照片' });
          this.loading = false;
          return;
        }
        const formData = new FormData();
        formData.append('name', this.form.name.trim());
        formData.append('idType', this.form.idType);
        formData.append('idNumber', this.form.idNumber.trim());
        formData.append('nationality', this.form.nationality.trim());
        formData.append('front', front);
        formData.append('back', back);
        var token = localStorage.getItem('token');
	    var language = localStorage.getItem("lang")||"en_us";
        formData.append('language', language);
        formData.append('token', token);
        const response = await axios.post(api.commonUrl + '/api/user/auth', formData);
        const info = response.data && response.data.info;
        const msg = typeof info === 'object'
          ? (info[language] || info.zh_cn || Object.values(info)[0])
          : (info || '');
        if (response.data && response.data.code == 1) {
          this.$toast({
            className: 'toastName',
            message: msg || '提交成功，请等待审核',
          });
          this.$router.replace('/safe');
        } else {
          this.$toast({ className: 'toastName', message: msg || '提交失败' });
        }
      } catch (e) {
        const errInfo = e.response && e.response.data && e.response.data.info;
        const lang = localStorage.getItem('lang') || 'zh_cn';
        const errMsg = typeof errInfo === 'object'
          ? (errInfo[lang] || errInfo.zh_cn || Object.values(errInfo)[0])
          : (errInfo || '提交失败');
        this.$toast({ className: 'toastName', message: errMsg });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.auth-manage-bg {
  min-height: 100vh;
  background: #f6f7fb;
}
.auth-header {
  display: flex;
  align-items: center;
  height: 43px;
  background: linear-gradient(to right, #ff5252, #ff8044);;
  box-shadow: 0 2px 8px rgba(255,107,47,0.08);
  position: relative;
}
.auth-header-back {
  width: 44px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.auth-header-title {
  flex: 1;
  text-align: center;
  color: #fff;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 2px;
  margin-right: 44px;
}
.auth-card {
  background: #fff;
  border-radius: 12px;
  margin: 18px 12px 0 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  padding: 0 0 8px 0;
}
.auth-item {
  display: flex;
  align-items: center;
  padding: 0 18px;
  height: 52px;
  background: #fff;
}
.auth-item-label {
  color: #333;
  font-size: 16px;
  width: 80px;
}
.auth-item-input {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 16px;
  color: #222;
  outline: none;
  padding: 12px 0;
}
.auth-item-input::placeholder {
  color: #b0b3c6;
}
.auth-select-wrap {
  position: relative;
}
.auth-item-select {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  font-size: 16px;
  color: #222;
  cursor: pointer;
}
.auth-item-select .placeholder {
  color: #b0b3c6;
}
.select-arrow {
  color: #b0b3c6;
  margin-left: 8px;
  transition: transform 0.2s;
}
.select-options-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
}
.select-options {
  width: 100%;
  max-width: 320px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  animation: slideUp 0.2s ease-out;
}
.select-option {
  padding: 16px;
  font-size: 16px;
  color: #222;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.2s;
  border-bottom: 1px solid #f2f2f2;
}
.select-option:last-child {
  border-bottom: none;
}
.select-option:active {
  background-color: #f6f7fb;
}
@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.auth-divider {
  height: 1px;
  background: #f2f2f2;
  margin: 0 18px;
}
.auth-upload-label {
  color: #b0b3c6;
  font-size: 15px;
  padding: 18px 18px 6px 18px;
}
.auth-upload-row {
  display: flex;
  gap: 16px;
  padding: 0 18px 18px 18px;
}
.auth-upload-card {
  flex: 1;
  background: #f6f7fb;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 0 10px 0;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.02);
  position: relative;
  overflow: hidden;
}
.auth-file-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 2;
}
.auth-upload-img {
  /* width: 60px; */
  height: 90px;
  object-fit: contain;
  margin-bottom: 8px;
}
.auth-upload-title {
  font-size: 15px;
  color: #ff6a2f;
  font-weight: 600;
  margin-bottom: 2px;
}
.auth-upload-desc {
  font-size: 13px;
  color: #b0b3c6;
}
.auth-btn-bar {
  margin: 32px 24px 0 24px;
}
.auth-btn {
  width: 100%;
  height: 48px;
  background: linear-gradient(90deg,#ff6a2f 0%,#ff3b3b 100%);
  color: #fff;
  border: none;
  border-radius: 24px;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 2px;
  box-shadow: 0 2px 8px rgba(255,107,47,0.08);
  transition: background 0.2s;
}
.auth-btn:disabled,
.auth-btn.auth-btn-disabled {
  opacity: 0.7;
}
</style>